import {observer} from 'mobx-react';
import {Select2, FormError, FormLayout} from 'shared/components';
import {Modal, ModalButtons} from 'shared/components/modals';

const AddEmployeeModal = observer(({modalOpen, uiState}) => {
  const {businessEntities, selectedBusinessEntityId, selectablePaySchedules, selectedPayScheduleId, errors} = uiState;

  const showBusinessEntityDropdown = businessEntities.length > 1;

  return (
    <Modal
      size='md'
      title='nmbr.employees.directory.Add to payroll'
      isOpen={modalOpen}
      onHide={() => uiState.closeAddEmployeeModal()}
    >
      <FormLayout>
        {showBusinessEntityDropdown && <Select2
          label='nmbr.employees.directory.Business Entity'
          value={selectedBusinessEntityId}
          onChange={e => uiState.onBusinessEntityChanged(e.target.value)}
          errorMessage={errors.nmbrBusinessEntityId}
        >
          {businessEntities.map(entity => <option value={entity.id} key={entity.id}>{entity.name}</option>)}
        </Select2>}
        {selectedBusinessEntityId && <Select2
          label='nmbr.employees.directory.Pay Schedule'
          value={selectedPayScheduleId}
          onChange={e => uiState.updateSelectedPayScheduleId(e.target.value)}
          errorMessage={errors.nmbrPayScheduleId}
        >
          {selectablePaySchedules.map(paySchedule => <option value={paySchedule.id} key={paySchedule.title}>{paySchedule.title}</option>)}
        </Select2>}
      </FormLayout>
      <FormError message={errors.base}/>
      <ModalButtons
        onSave={() => uiState.addEmployee()}
        saveCaption={'nmbr.employees.directory.Add'}
        onCancel={() => uiState.closeAddEmployeeModal()}
      />
    </Modal>
  );
});

export default AddEmployeeModal;
